import { Spinner, Table } from "react-bootstrap"

import ExcludeClinicGroupRow from "./ExcludeClinicGroupRow"
import { ClinicGroupSelected } from "../../../../api/Clinics/Models/ClinicGroup"

interface IExcludeClinicGroupTableProps {
  groups: ClinicGroupSelected[]
  loadingGroups: boolean
  onSelectGroup: (group: ClinicGroupSelected) => void
}

function ExcludeClinicGroupTable(props: IExcludeClinicGroupTableProps) {
  const { groups, loadingGroups, onSelectGroup } = props

  return (
    <Table className="table-sm dark my-0" borderless responsive>
      <thead>
        <tr>
          <th>Group Name</th>
        </tr>
      </thead>
      <tbody>
        {loadingGroups && (
          <tr>
            <td colSpan={2} className="text-center">
              <Spinner animation="border" variant="secondary" className="mb-1" />
            </td>
          </tr>
        )}
        {!loadingGroups && groups.length === 0 && (
          <tr>
            <td>NO GROUPS FOUND</td>
          </tr>
        )}
        {!loadingGroups &&
          groups.map((group) => (
            <ExcludeClinicGroupRow key={group.SearchRestrictId} group={group} onClick={onSelectGroup} />
          ))}
      </tbody>
    </Table>
  )
}

export default ExcludeClinicGroupTable
